import { ShapeProps } from './types';

const Circle = ({ fill, size }: ShapeProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 187 186"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="93.25" cy="93" r="93" fill={fill} />
		</svg>
	);
};

export default Circle;
